import firebase, { db, googleProvider } from "../config/Firebase";
import React, { useState, useEffect, createContext, useContext } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [isAuth, setIsAuth] = useState(false);
  const [activeUser, setactiveUser] = useState({});
  // debugger;
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
        db.collection("users")
          .where("uid", "==", user.uid)
          .onSnapshot((snap) => {
            const users = [];
            snap.forEach((doc) => {
              const user = doc.data();
              user.id = doc.id;
              users.push(user);
            });
            if (users.length > 0) {
              setIsAuth(true);
              setactiveUser(users[0]);
            } else {
              setIsAuth(false);
              setactiveUser({});
            }
          });
      } else {
        setUser({});
        setactiveUser({});
        setIsAuth(false);
      }
    });
  }, []);
  const login = (email, password, resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((a) => resolve(a))
      .catch((err) => reject(err));
  };
  const currentUser = () => firebase.auth().currentUser;
  const signup = (
    email,
    password,
    firstname,
    lastname,
    notificationsEnabled,
    resolve,
    reject
  ) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((a) => {
        db.collection("users")
          .doc(a.user.uid)
          .set({
            email,
            time: new Date().getTime(),
            firstname,
            lastname,
            notificationsEnabled,
            uid: a.user.uid,
            role: "user",
          })
          .then(() => resolve(a))
          .catch((e) => reject(e));
      })
      .catch((err) => reject(err));
  };
  const logout = () => {
    firebase.auth().signOut();
  };
  const googleLogin = () => {
    firebase
      .auth()
      .signInWithPopup(googleProvider)
      .then((result) => {
        if (result.additionalUserInfo.isNewUser) {
          const [firstname, ...lastname] = result.user.displayName.split(" ");
          db.collection("users")
            .doc(result.user.uid)
            .set({
              email: result.user.email,
              notificationsEnabled: true,
              time: new Date().getTime(),
              firstname,
              lastname: lastname.join(" "),
              uid: result.user.uid,
              role: "user",
            });
        }
      });
  };
  const reset = (email, res, rej) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then((el) => res(el))
      .catch((err) => rej(err));
  };
  const verify = (res, rej) => {
    firebase
      .auth()
      .currentUser.sendEmailVerification()
      .then((e) => res(e))
      .catch((e) => rej(e));
  };
  const value = {
    user,
    isAuth,
    verify,
    reset,
    setIsAuth,
    login,
    signup,
    currentUser,
    activeUser,
    logout,
    googleLogin,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;
